import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/notifications")({
	component: RouteComponent
});

function RouteComponent() {
	return <div>Hello "/vendor/notifications"!</div>;
}
